"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PORTALS_ROOT_SELECTOR = exports.PORTALS_ROOT_ID = void 0;
var PORTALS_ROOT_ID = 'key-popovers';
exports.PORTALS_ROOT_ID = PORTALS_ROOT_ID;
var PORTALS_ROOT_SELECTOR = "#".concat(PORTALS_ROOT_ID);
exports.PORTALS_ROOT_SELECTOR = PORTALS_ROOT_SELECTOR;